(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gnd-contact-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('gnd-general-contact');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const preference = dialog.querySelector('#gnd-contact-preference');
  const phone = dialog.querySelector('#gnd-contact-phone');
  let opener;
  const open = (source) => {
    opener = source;
    if (!dialog.open) dialog.showModal();
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/contact\/?$/i.test(url.pathname)) return;
    event.preventDefault();
    open(link);
  });
  dialog.querySelector('.gnd-contact-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
  preference.addEventListener('change', () => { phone.required = preference.value === 'Text message'; });
  const form = dialog.querySelector('form');
  form.addEventListener('submit', () => { sessionStorage.setItem('gnd-general-contact-pending','1'); });
  if (sessionStorage.getItem('gnd-general-contact-pending') === '1' && (location.hash === '#gnd-contact-sent' || dialog.querySelector('[data-contact-errors]'))) {
    open();
    sessionStorage.removeItem('gnd-general-contact-pending');
  }
})();
  } catch(e) { console.error(e); }
})();

})();
